import { defineMessages } from "react-intl";

import { node as fvs } from "src/modules/basic-health/forms/lab-procedures/fvs";
import { node as ggt } from "src/modules/basic-health/forms/lab-procedures/ggt";
import { node as got } from "src/modules/basic-health/forms/lab-procedures/got";
import { node as gpt } from "src/modules/basic-health/forms/lab-procedures/gpt";
import { node as haemoglobin } from "src/modules/basic-health/forms/lab-procedures/haemoglobin";
import { node as serumGlucose } from "src/modules/basic-health/forms/lab-procedures/serumGlucose";
import { ParentNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	title: {
		id: "form.lab_procedures",
		defaultMessage: "Laborvizsgálatok"
	}
});

export const node: ParentNode = {
	id: "basic-health-lab-procedures",
	value: { type: "list", title: messages.title, columns: 2 },
	children: [fvs, haemoglobin, got, gpt, ggt, serumGlucose]
};
